<template>
    <div v-if="isVisible" class="modal">
      <div class="modal-content">
        <span @click="isVisible = false" class="close">&times;</span>
        <h2>Product Details</h2>
        <!-- Product details can go here -->
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "ModalProduct",
    data() {
      return {
        isVisible: false,
      };
    },
    methods: {
      openModal() {
        this.isVisible = true;
      },
    },
  };
  </script>
  
  <style scoped>
  .modal {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    z-index: 1000;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
  }
  
  .modal-content {
    background-color: white;
    padding: 20px;
    border-radius: 5px;
  }
  
  .close {
    cursor: pointer;
    float: right;
  }
  </style>
  